import { FlexDiv } from 'components/generic/HomePageComponents'
import { MainLoadingSkeleton } from 'components/Directories/Styled'
import {
  ImageCTAContainer,
  ImageCTATitle,
  ImageCTABodyText,
  CTALazyImage,
  CTAButtonContainer,
  KathyCTAButton,
} from './Styled'

const KathyCTA = ({
  kathyCtaTitle,
  kathyCtaImage,
  kathyCtaText,
  kathyCtaButtonLink,
  kathyCtaButtonText,
  hasListing,
  isLoading,
}) => {
  if (hasListing === false) {
    if (isLoading === false) {
      return (
        <ImageCTAContainer display={{ _: 'block', desktop: 'flex' }}>
          <FlexDiv p='1rem' width={{ _: 'inherit', desktop: '60%' }}>
            <CTALazyImage src={kathyCtaImage} alt='Kathys tip image' />
            <div>
              <ImageCTATitle>{kathyCtaTitle}</ImageCTATitle>
              <ImageCTABodyText>{kathyCtaText}</ImageCTABodyText>
            </div>
          </FlexDiv>
          <CTAButtonContainer display='flex' ml='0px'>
            <KathyCTAButton
              href={kathyCtaButtonLink}
              display='block'
              fontSize='16px'
              padding='16px'
              maxWidth='16rem'
              mb='0px'
            >
              {kathyCtaButtonText}
            </KathyCTAButton>
          </CTAButtonContainer>
        </ImageCTAContainer>
      )
    } else {
      return (
        <MainLoadingSkeleton
          mt='24px'
          minWidth={{ _: '335px', tablet: '360px', desktop: '945px' }}
          minHeight={{ _: '250px', tablet: '227px', desktop: '135px' }}
        />
      )
    }
  }
  return null
}

export default KathyCTA
